// extracted by mini-css-extract-plugin
module.exports = {"footer":"board-footer_footer__1BzGi","lot-number":"board-footer_lot-number__3iQnD","lot-bidder":"board-footer_lot-bidder__3CGuG"};